import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVenturi = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 40,
	viewBox: "0 0 50.0 40.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 0.0 A 60.0 60.0 0.0 0 0 50.0 0.0 L 50.0 40.0 A 60.0 60.0 0.0 0 0 0.0 40.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgVenturi;
